import type { SVGProps } from "react";
import * as React from "react";

const SvgFilePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m14 2 .707-.707A1 1 0 0 0 14 1zM6 2V1zM4 4H3zm0 16H3zM20 8h1a1 1 0 0 0-.293-.707zm-6 0h-1a1 1 0 0 0 1 1zm-3 10a1 1 0 1 0 2 0zm2-6a1 1 0 1 0-2 0zm-4 2a1 1 0 1 0 0 2zm6 2a1 1 0 1 0 0-2zM14 1H6v2h8zM6 1a3 3 0 0 0-2.121.879l1.414 1.414A1 1 0 0 1 6 3zm-2.121.879A3 3 0 0 0 3 4h2a1 1 0 0 1 .293-.707zM3 4v16h2V4zm0 16a3 3 0 0 0 .879 2.121l1.414-1.414A1 1 0 0 1 5 20zm.879 2.121A3 3 0 0 0 6 23v-2a1 1 0 0 1-.707-.293zM6 23h12v-2H6zm12 0a3 3 0 0 0 2.121-.879l-1.414-1.414A1 1 0 0 1 18 21zm2.121-.879A3 3 0 0 0 21 20h-2a1 1 0 0 1-.293.707zM21 20V8h-2v12zm-.293-12.707-6-6-1.414 1.414 6 6zM13 2v6h2V2zm1 7h6V7h-6zm-1 9v-6h-2v6zm-4-2h6v-2H9z"
    />
  </svg>
);
export default SvgFilePlus;
